import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/content";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState("overview");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 24);

      let current = navLinks[0].id;
      navLinks.forEach((link) => {
        const el = document.getElementById(link.id);
        if (el && el.getBoundingClientRect().top <= 140) {
          current = link.id;
        }
      });
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleJump = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200/80"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="px-4 md:px-8">
        <div className="h-16 md:h-20 flex items-center justify-between gap-4">
          <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-2.5 cursor-pointer shrink-0"
            aria-label="返回页面顶部"
          >
            <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-lg">
              <i className="ri-heart-3-fill" aria-hidden="true" />
            </span>
            <span className="flex flex-col items-start leading-none">
              <span className="font-heading text-lg font-bold text-foreground-950">红桃影视</span>
              <span className="font-label text-[10px] tracking-[0.2em] text-foreground-500 mt-1">
                HONGTAO CINEMA
              </span>
            </span>
          </button>

          <nav className="hidden md:flex items-center gap-1" aria-label="页面分区导航">
            {navLinks.map((link) => (
              <button
                key={link.id}
                type="button"
                onClick={() => handleJump(link.id)}
                className={`px-3.5 py-2 rounded-md text-sm font-label transition-colors cursor-pointer ${
                  active === link.id
                    ? "text-primary-600 bg-primary-50"
                    : "text-foreground-600 hover:text-foreground-950 hover:bg-background-100"
                }`}
              >
                {link.label}
              </button>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <button
              type="button"
              onClick={() => handleJump("library")}
              className="whitespace-nowrap inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-search-line" aria-hidden="true" />
              片库检索
            </button>
          </div>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <nav className="flex flex-col" aria-label="移动端分区导航">
            {navLinks.map((link) => (
              <button
                key={link.id}
                type="button"
                onClick={() => handleJump(link.id)}
                className="flex items-center justify-between py-3 border-b border-background-100 last:border-b-0 text-sm font-label text-foreground-800 cursor-pointer"
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true" />
              </button>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}